export default theme => ({
  details: {
    fontSize: 14,
    color: '#424953',
  },
  detailsRow: {
    marginBottom: 10
  },
  icons: {
    color: '#424953',
  },
  shareIconsWrapper: {
    textAlign: 'center'
  },
  shareIcon: {
    fontSize: 22,
    margin: 5,
  },
  shortlink: {
    border: '1px solid #ccc',
    background: '#eee',
    maxWidth: 150,
    textAlign: 'center',
    padding: '0 8px',
    fontSize: 14,
    lineHeight: '24px'
  },
  sharesLabel: {
    fontSize: 12
  },
})

